import {
  $attachCard,
  $cancelPlan,
  $cancelPreauthIntent,
  $capturePaypalOrder,
  $changeApiPlan,
  $changeLtdPlanDuration,
  $changePLan,
  $checkUpsellAllowed,
  $createBillingPortal,
  $createLtdPaymentCheckout,
  $createPreauthIntent,
  $createSubscriptionCheckout,
  $creatSetupCheckoutSession,
  $getApiSubscription,
  $getCard,
  $getInvoiceDownloadLink,
  $getInvoices,
  $getLatestInvoice,
  $getLtdTier,
  $getLtdTiers,
  $getLtdUpcomingInvoice,
  $getPlans,
  $getSubscriptionData,
  $getUpcomingInvoice,
  $redeemLtdCode,
  $removeApiPlan,
  $retryCharge,
  $temporaryChangePlan,
  $updateCard,
  $upgradeAppSumo,
  $upgradeLtdPaymentCheckout,
  $upsellPlan,
  $validateLtdCode,
  $validatePromotionCode,
  attachCard,
  cancelPreauthIntent,
  capturePaypalOrder,
  changeApiPlan,
  changeLtdPlanDuration,
  changePLan,
  checkUpsellAllowed,
  createBillingPortal,
  createLtdPaymentCheckout,
  createPreauthIntent,
  createSubscriptionCheckout,
  creatSetupCheckoutSession,
  getApiSubscription,
  getCard,
  getInvoiceDownloadLink,
  getInvoices,
  getLatestInvoice,
  getLtdTier,
  getLtdTiers,
  getLtdUpcomingInvoice,
  getPlans,
  getSubscriptionData,
  getUpcomingInvoice,
  redeemLtdCode,
  removeApiPlan,
  retryCharge,
  temporaryChangePlan,
  updateCard,
  upgradeAppSumo,
  upgradeLtdPaymentCheckout,
  upsellPlan,
  validateLtdCode,
  validatePromotionCode,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    getCard,
    getApiSubscription,
    getPlans,
    upgradeAppSumo,
    attachCard,
    changePLan,
    changeApiPlan,
    getSubscriptionData,
    updateCard,
    removeApiPlan,
    getInvoices,
    retryCharge,
    upsellPlan,
    validatePromotionCode,
    getLatestInvoice,
    creatSetupCheckoutSession,
    createSubscriptionCheckout,
    createLtdPaymentCheckout,
    upgradeLtdPaymentCheckout,
    checkUpsellAllowed,
    createBillingPortal,
    getUpcomingInvoice,
    getLtdUpcomingInvoice,
    getInvoiceDownloadLink,
    changeLtdPlanDuration,
    capturePaypalOrder,
    getLtdTier,
    getLtdTiers,
    validateLtdCode,
    redeemLtdCode,
    temporaryChangePlan,
    createPreauthIntent,
    cancelPreauthIntent,
  },
};

export const $actions = {
  getInvoices: $getInvoices,
  getApiSubscription: $getApiSubscription,
  removeApiPlan: $removeApiPlan,
  getCard: $getCard,
  attachCard: $attachCard,
  upgradeAppSumo: $upgradeAppSumo,
  changeApiPlan: $changeApiPlan,
  getPlans: $getPlans,
  getSubscriptionData: $getSubscriptionData,
  updateCard: $updateCard,
  changePLan: $changePLan,
  cancelPlan: $cancelPlan,
  retryCharge: $retryCharge,
  upsellPlan: $upsellPlan,
  validatePromotionCode: $validatePromotionCode,
  getLatestInvoice: $getLatestInvoice,
  creatSetupCheckoutSession: $creatSetupCheckoutSession,
  createSubscriptionCheckout: $createSubscriptionCheckout,
  createLtdPaymentCheckout: $createLtdPaymentCheckout,
  upgradeLtdPaymentCheckout: $upgradeLtdPaymentCheckout,
  checkUpsellAllowed: $checkUpsellAllowed,
  createBillingPortal: $createBillingPortal,
  getUpcomingInvoice: $getUpcomingInvoice,
  getLtdUpcomingInvoice: $getLtdUpcomingInvoice,
  getInvoiceDownloadLink: $getInvoiceDownloadLink,
  changeLtdPlanDuration: $changeLtdPlanDuration,
  capturePaypalOrder: $capturePaypalOrder,
  getLtdTier: $getLtdTier,
  getLtdTiers: $getLtdTiers,
  validateLtdCode: $validateLtdCode,
  redeemLtdCode: $redeemLtdCode,
  temporaryChangePLan: $temporaryChangePlan,
  createPreauthIntent: $createPreauthIntent,
  cancelPreauthIntent: $cancelPreauthIntent,
};
